import {
  changeCoverageToBbva as axiosChangeCoverageToBbva,
  getPets as axiosGetPets,
  postPet as axiosNewPet,
  postSolicitudCambioPet as axiosPostSolicitudCambioPet,
} from '../../axios/Pet';
import {
  ChangeCoverageReq,
  Pet,
  PetReq,
  SolicitudCambioPetReq,
} from '../../types/Pet/types';
import { useCreateEntity, useFetchEntity } from '../Utils/useEntity';

const usePostPet = () => {
  const { create, isLoading, error } = useCreateEntity<PetReq, boolean>(axiosNewPet);

  return { postPet: create, isLoading, error };
};

const useSolicitudCambioPet = () => {
  const { create, isLoading, error } = useCreateEntity<SolicitudCambioPetReq, boolean>(
    axiosPostSolicitudCambioPet,
  );

  return { postSolicitudCambioPet: create, isLoading, error };
};

const useChangeCoverageToBbva = () => {
  const { create, isLoading, error } = useCreateEntity<ChangeCoverageReq, boolean>(
    axiosChangeCoverageToBbva,
  );

  return { changeCoverageToBbva: create, isLoading, error };
};

const useGetPets = (enabled: boolean = true) => {
  const { data, error, isValidating, mutate } = useFetchEntity<Pet[]>(
    enabled ? 'pets' : null,
    axiosGetPets,
  );

  return {
    pets: data,
    error,
    isValidating,
    mutate,
  };
};

export { usePostPet, useSolicitudCambioPet, useChangeCoverageToBbva, useGetPets };
